import CouponEventHomeContainer from './CouponEventHomeContainer';
export default CouponEventHomeContainer;
